import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-commerce-management',
  templateUrl: './commerce-management.component.html',
  styleUrls: ['./commerce-management.component.scss']
})
export class CommerceManagementComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
